import { Component, OnInit } from "@angular/core";
import { AlertController, LoadingController } from "@ionic/angular";
import { Subscription } from "rxjs";
import { GeoResponse } from "src/app/interfaces/geo-interface";
import { EventsService } from "src/app/services/event/event.service";
import { JurisdictionService } from "src/app/services/geo/jurisdiction.service";
import { UserSessionService } from "src/app/services/user-session/user-session.service";
import { Navigator } from "src/app/services/routing/navigator";
import { ConfigService } from "src/app/services/config/config.service";

@Component({
    selector: 'init-geocomply',
    standalone: true
})

export class InitGeoComply implements OnInit {

    public geoLoadingText: any;
    public geoRunning: any;
    public isAuthenticated: boolean;
    public jurisdictionSubscription: Subscription;
    public showGeoDialogRunningCheck: boolean;
    public uiAction;

    constructor(
        private alertController: AlertController,
        private config: ConfigService,
        private events: EventsService,
        private jurisdiction: JurisdictionService,
        private loadingController: LoadingController,
        private navigator: Navigator,
        private userSessionService: UserSessionService,
    ) {
    }

    ngOnInit(): void {
        if (this.userSessionService.isAuthenticated) this.initGeoComply();

        this.showGeoDialogRunningCheck = this.config.getConfig().FEATURE_SHOW_GEO_RUNNING_DIALOG === '1' ? true : false
        this.events.subscribe('event:geoComply:present', () => {
            if (this.showGeoDialogRunningCheck) {
                if (window.document.hasFocus()) {
                    if (!this.geoRunning) {
                        this.init();
                    }

                    this.geoRunning.then((loadingDialog) => {
                        loadingDialog.present();
                    });
                }
            }

        });

        this.events.subscribe('event:geoComply:dismiss', () => {
            if (this.showGeoDialogRunningCheck) {
                if (this.geoRunning) {
                    this.geoRunning.then((loadingDialog) => {
                        loadingDialog.dismiss();
                    });
                    this.geoRunning = null;
                }
            }
        });
    }

    ngOnDestroy() {
        if (this.jurisdictionSubscription) {
            this.jurisdictionSubscription.unsubscribe();
            this.jurisdiction.cancelGeolocation();
        }
    }

    public init() {
        this.geoLoadingText = this.config.getConfig().FEATURE_GEO_SPINNER_TEXT ?? 'Loading game...'
        this.geoRunning = this.loadingController.create({
            message: this.geoLoadingText
        });
    }

    public initGeoComply() {
        var errorDialog: boolean = true;

        this.events.subscribe('event:geoComply:SuppressErrorDialog', () => {
            errorDialog = false;
        });

        this.events.subscribe('event:geoComply:EnableErrorDialog', () => {
            errorDialog = true;
        });

        if (this.jurisdictionSubscription) {
            this.jurisdictionSubscription.unsubscribe();
        }

        this.jurisdictionSubscription = this.jurisdiction.listen().subscribe((geoResp: GeoResponse) => {
            if (!geoResp.is_allowed && errorDialog) {
                this.navigator.navigateTo('GeoComplyComponent', {}, { params: { geoComplyStatus: geoResp.error, funcToRetry: this.jurisdiction.getFuncToRetry() } });
            } else {
                this.jurisdiction.resumeNotifications();
            }
        });
    }
}